module.exports = __webpack_public_path__ + "static/img/2.f4ca5ed2.png";